import React from 'react';
import { FileText } from 'lucide-react';
import Accordion from '../../components/Accordion/Accordion';
import './Pesquisas.css';

const researches = [
  {
    id: 1,
    title: 'Questionário - Plano Municipal de Saneamento Básico de Paraisópolis',
    description: 'Participe respondendo ao formulário sobre o saneamento básico em Paraisópolis.',
    formUrl: 'https://forms.gle/iL3QtsBeCfgsP3TW9',
    embedUrl: 'https://forms.gle/iL3QtsBeCfgsP3TW9?embedded=true',
    date: 'Aberto'
  }
];

const Pesquisas = () => {
  const accordionItems = researches.map((research) => ({
    title: research.title,
    metadata: research.date,
    leading: <FileText aria-hidden="true" />,
    content: (
      <div className="research-item">
        <p className="research-item__description">{research.description}</p>

        <div className="form-embed">
          <iframe
            title={research.title}
            src={research.embedUrl}
            loading="lazy"
          >
            Carregando…
          </iframe>
        </div>

        <p className="form-fallback">
          Se o formulário não carregar,{' '}
          <a
            href={research.formUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            clique aqui para abrir em nova aba
          </a>.
        </p>
      </div>
    )
  }));

  return (
    <div className="research-page">
      <section className="page-hero">
        <div className="page-hero__text">
          <span className="page-hero__eyebrow">Pesquisas</span>
        </div>
      </section>

      <section className="research-content">
        <div className="research-intro">
          <p className="research-intro__text">
            Participe das pesquisas e questionários para contribuir com o desenvolvimento do Plano Municipal de Saneamento Básico.
          </p>
        </div>

        {/* <div style={{
          textAlign: 'center',
          padding: '4rem 2rem',
          color: '#666',
          fontSize: '1.125rem'
        }}>
          <p>Por enquanto não há pesquisas disponíveis.</p>
          <p style={{ marginTop: '1rem', fontSize: '1rem' }}>
            Em breve, você poderá participar de pesquisas e questionários sobre o saneamento básico.
          </p>
        </div> */}

        <div className="research-accordion">
          <Accordion items={accordionItems} />
        </div>
      </section>
    </div>
  );
};

export default Pesquisas;
